export const actionTypes = {
  SAVE_CLIENT: 'SAVE_CLIENT',
};

export const saveSDKClient = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_CLIENT,
    data: data,
  });
};
